<template>
  <div class="service__card" v-if="card" width="300">
    <div class="service__card__inner">
      <div class="service__card__category">
        <div class="service__card__actions">
          <button
            class="service__card__edit black--text"
            @click="editNote(card)"
          >
            Edit
          </button>
          <button
            class="service__card__edit black--text"
            @click="showNote(card)"
          >
            Show
          </button>
          <button
            class="service__card__edit black--text"
            @click="removeNote(card)"
          >
            Delete
          </button>
          <!-- <button class="service__card__edit" @click="toggle()">
            {{ label }}
          </button> -->
        </div>
      </div>

      <div class="service__card__title">
        <h4 class="black--text" :style="{ background: color }">
          {{ card.title }}
        </h4>
      </div>
      <div
        class="service__card__description"
        :style="{ background: color }"
        v-if="card.description"
      >
        <p v-html="card.description"></p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "RowCard",
  data() {
    return {
      open: false,
    };
  },
  props: {
    card: Object,
    all: Array,
    color: String,
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedOpen() {
      return this.isOpen || this.open ? true : false;
    },
    exapndable() {
      if (this.subitems || this.description) {
        return this.subitems || this.description ? true : false;
      } else {
        return this.description ? true : false;
      }
    },
    label() {
      return this.open ? "Close" : "Expand";
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    editNote(id) {
      this.$emit("editNote", id);
    },
    showNote(id) {
      this.$emit("showNote", id);
    },
    removeNote(id) {
      this.$emit("removeNote", id);
    },
  },
};
</script>
